import {
  IonButton,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonLoading,
  IonPage,
  IonRadio,
  IonRadioGroup,
  IonText,
  IonTextarea,
  useIonToast,
} from "@ionic/react";
import { star, starOutline } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import Header from "src/components/Header";
import { enviarFeedback, obtenerFeedback } from "src/services/atencionCliente";

const Estrellas: React.FC<{
  value: number;
  onChange: (n: number) => void;
}> = ({ value, onChange }) => (
  <div style={{ display: "flex", gap: "0.25rem", padding: "0.5rem 0" }}>
    {[1, 2, 3, 4, 5].map((n) => (
      <IonIcon
        key={n}
        icon={n <= value ? star : starOutline}
        style={{ fontSize: "2rem", cursor: "pointer", color: "#f5a623" }}
        onClick={() => onChange(n)}
      />
    ))}
  </div>
);

const AtcFeedback: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const citaId = parseInt(id, 10);
  const history = useHistory();
  const [present] = useIonToast();

  const [cargando, setCargando] = useState(true);
  const [yaEnviado, setYaEnviado] = useState(false);

  const [calGeneral, setCalGeneral] = useState(0);
  const [calResponsable, setCalResponsable] = useState(0);
  const [seResolvio, setSeResolvio] = useState<boolean | null>(null);
  const [comentario, setComentario] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const fb = await obtenerFeedback(citaId);
        if (fb) setYaEnviado(true);
      } catch (err) {
        const msg = err instanceof Error ? err.message : "Error al cargar";
        present({ message: msg, duration: 3000, color: "danger" });
      } finally {
        setCargando(false);
      }
    })();
  }, [citaId, present]);

  const enviar = async () => {
    if (calGeneral === 0 || calResponsable === 0 || seResolvio === null) {
      present({
        message: "Completa todas las calificaciones.",
        duration: 2500,
        color: "warning",
      });
      return;
    }
    setCargando(true);
    try {
      await enviarFeedback(citaId, {
        calificacion_general: calGeneral,
        calificacion_responsable: calResponsable,
        se_resolvio: seResolvio,
        comentario: comentario,
      });
      present({ message: "Gracias por tu encuesta.", duration: 2500, color: "success" });
      history.replace("/atencion-cliente");
    } catch (err) {
      const msg = err instanceof Error ? err.message : "No se pudo enviar";
      present({ message: msg, duration: 3500, color: "danger" });
    } finally {
      setCargando(false);
    }
  };

  if (cargando) {
    return (
      <IonPage>
        <Header titulo="Encuesta de Atencion" />
        <IonContent>
          <IonLoading isOpen={true} message="Cargando..." />
        </IonContent>
      </IonPage>
    );
  }

  if (yaEnviado) {
    return (
      <IonPage>
        <Header titulo="Encuesta de Atencion" />
        <IonContent>
          <div style={{ padding: "2rem", textAlign: "center" }}>
            <IonText>
              <h3>Ya enviaste la encuesta de esta cita.</h3>
              <p>La encuesta es inmodificable una vez enviada.</p>
            </IonText>
            <IonButton onClick={() => history.replace("/atencion-cliente")}>
              Volver
            </IonButton>
          </div>
        </IonContent>
      </IonPage>
    );
  }

  return (
    <IonPage>
      <Header titulo="Encuesta de Atencion" />
      <IonContent>
        <div style={{ padding: "1rem" }}>
          <IonText color="medium">
            <p>Tu opinion nos ayuda a mejorar la atencion interna.</p>
          </IonText>

          <h4>Calificacion general de la atencion</h4>
          <Estrellas value={calGeneral} onChange={setCalGeneral} />

          <h4>Calificacion del responsable que te atendio</h4>
          <Estrellas value={calResponsable} onChange={setCalResponsable} />

          <h4>Se resolvio tu consulta?</h4>
          <IonRadioGroup
            value={seResolvio === null ? "" : seResolvio ? "si" : "no"}
            onIonChange={(e) => setSeResolvio(e.detail.value === "si")}
          >
            <IonItem>
              <IonLabel>Si</IonLabel>
              <IonRadio slot="end" value="si" />
            </IonItem>
            <IonItem>
              <IonLabel>No</IonLabel>
              <IonRadio slot="end" value="no" />
            </IonItem>
          </IonRadioGroup>

          <IonItem>
            <IonLabel position="stacked">Comentario (opcional)</IonLabel>
            <IonTextarea
              value={comentario}
              onIonChange={(e) => setComentario(e.detail.value || "")}
              rows={4}
            />
          </IonItem>

          <div style={{ marginTop: "1.5rem" }}>
            <IonButton expand="block" color="success" onClick={() => void enviar()}>
              Enviar encuesta
            </IonButton>
            <IonButton
              expand="block"
              fill="clear"
              color="medium"
              onClick={() => history.goBack()}
            >
              Atras
            </IonButton>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default AtcFeedback;
